// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clipboardCheckIcon from "@/assets/icons/clipboard-check.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClipboardCheckIconProps = Omit<IconProps, "name">;

export function ClipboardCheckIcon(props: ClipboardCheckIconProps): React.ReactNode {
  return <Icon name={clipboardCheckIcon} {...props} />;
}
